import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Form, InputNumber, Modal, Input, Radio, Upload, Card, message, Icon} from 'antd';
import BaseComponent from "../../../base/BaseComponent";
import {HEADER_HEIGHT, ONLY_PIC_TYPE_NEW, PIC_TYPE, PIC_TYPE_ORIGINAL} from "../../../constants";
import PageTableComponent from "../../../view/resource/components/pageTable/PageTable";
import UploadWall from "../../../components/upload/UploadWall";



export default class HonorManagement  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            visible:false,
             current:{},//当前配置项
            dataSource:[],
            Honor: {
                title: '',
                grade: '',
                score: '',
                href: ''

            }
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
      this.getData()
    }

    getData = ()=>{
        this.request({
            url:  "/cm-sites-sys/config/getByConfigKey?configKey=integralManger ",
            method: 'post',
            contentType: "json",
            callBack: (res) => {
                if(res){
                    this.state.current = res;
                    this.state.dataSource =  JSON.parse(res.configValue)
                }
                this.setState({})
            },
            errorCallBack: (e) => {
                message.error('操作失败！');
            },
        })
    };

    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT -32;

        return(
            <div style={{
                background: '#ffffff',
                padding: '24px 15px',
                margin: "15px 0 15px 15px",
                position: 'relative',
                borderRadius:5
            }} >
                {this.renderList()}

                {this.renderModel()}


            </div>

        )
    }

    renderList = () =>{

        let columns = [
            {
                title: '荣誉称号',
                key: 'title',
                dataIndex: 'title',
                ellipsis: true,

            },  {
                title: '荣誉等级',
                key: 'grade',
                dataIndex: 'grade',
                ellipsis: true,
            }, {
                title: '满分积分数',
                key: 'score',
                dataIndex: 'score',
                ellipsis: true,
            },{
                title: '荣誉图片',
                key: 'href',
                dataIndex: 'href',
                ellipsis: true,
                render: (text, record) => {
                    return (text? <img src={text}  style={{width: 40,objectFit: "cover",}}/>:'')}

            },{
                title: '操作',
                dataIndex: 'address',
                render: (text, record) => {
                    return (<div style={{color: '#0050B3', cursor: "pointer"}}>
                        <span onClick={() => {
                            this.edit(record)
                        }}>编辑</span>
                    </div>)
                }

            }];
        return (
            <div id={'honor'} >
                <PageTableComponent
                    columns={columns}
                    rowKey = {'userId'}
                    rowSelection={false}
                    data={this.state.dataSource}
                    page={1}
                    size={10}
                    count={0}
                    onChangePage={(page, size) => {
                        this.onChangePage(page, size)
                    }}
                ></PageTableComponent>{

                <style>{`
                                #honor .cm-table-body{
                                   margin-top:0 !important
                                }
                              
                          `}</style>
            }</div>

        )
    };

    edit = (item) =>{
        this.state.visible  = true;
        this.state.Honor = JSON.parse(JSON.stringify(item));
        this.setState({})
    };

    renderModel = () =>{
        let accept = PIC_TYPE_ORIGINAL&&PIC_TYPE_ORIGINAL.map(item=>("."+item)).join(",");
        const uploadButton = (
            <div>
                <div style={{marginTop: 8}}><Icon type={this.state.loading ? "loading" : "plus"}/></div>
            </div>
        );
        let {Honor} = this.state;
        return (
            <Modal
                title='编辑荣誉'
                visible={this.state.visible}
                width={500}
                centered
                maskClosable ={false}
                onOk={() => {
                    this.saveData()
                }}
                onCancel={() => {
                    this.setState({visible:false})
                }}
            >
                <div>
                    <Form.Item label={'荣誉称号'} required style={{display:"flex"}} className={'pointDeduct'}>
                        <Input  placeholder="请输入荣誉称号"   value={this.state.Honor.title}  style={{width:300}} onChange={(e)=>{
                           this.onChange('title',e.target.value)
                        }} />
                    </Form.Item>

                    <Form.Item label={'荣誉等级'} required style={{display:"flex"}} className={'pointDeduct'} >
                        <InputNumber  placeholder="请输入荣誉等级"  min={0} precision={0} value={this.state.Honor.grade}  style={{width:300}} onChange={(e)=>{
                            this.onChange('grade',e)
                        }} />
                    </Form.Item>
                    <Form.Item label={"满足积分值"} required style={{display:"flex"}} className={'pointDeduct'}>
                        <InputNumber  placeholder="请输入满足积分值"  min={0} precision={0} value={this.state.Honor.score}  style={{width:300}} onChange={(value)=>{
                            this.onChange('score',value)
                        }} />
                    </Form.Item>
                    <Form.Item label={"荣誉图片"} required style={{display:"flex"}} className={'pointDeduct'}>
                        <Upload
                            accept={accept}
                            name="file"
                            listType="picture-card"
                            className="avatar-uploader"
                            showUploadList={false}
                            action="/storage/uploadFile"
                            beforeUpload={this.handleBeforeUpload}
                            onChange={(info) => this.handleChange(info)}
                        >
                            {Honor&&Honor.href?
                                <img src={Honor.href} alt="avatar" style={{width: '100%'}}/> : uploadButton}
                        </Upload>


                    </Form.Item>

                    <style>{`
                        .pointDeduct .ant-form-item-label{
                            width: 100px;
                            vertical-align: top
                        }
                               
              `}</style>
                </div>


            </Modal>)
    };

    onChange = (name,text) =>{
       this.state.Honor[name] = text;
       this.setState({})
    };

    //上传前添加上传提示，限制非格式的上传
    handleBeforeUpload = (file, fileList) => {
        let fileName = file.name.split('.');
        let upload = fileName.at(-1).toUpperCase();
        upload = PIC_TYPE.includes(upload);
        if(!upload){
            message.error('暂不支持该文件类型!');
        }
        return new Promise((resolve, reject) => {
            if (!upload) {
                reject(file);
            } else {
                resolve(file);
            }
        });
    };

    handleChange = info => {
        if (info.file.status === 'uploading') {
            return;
        }
        if (info.file.status === 'done') {
            this.state.Honor.href =  info.file.response.data.path;
            this.setState({})

        }
    };

    saveData = () =>{
        let {Honor} = this.state;
        if(Honor.title ===''){
            message.destroy();
            message.warning('请输入荣誉称号');
            return false
        }
        if(Honor.grade ===''){
            message.destroy();
            message.warning('请输入荣誉等级');
            return false
        }
        if(Honor.score ===''){
            message.destroy();
            message.warning('请输入满足积分值');
            return false
        }
        if(Honor.href ===''){
            message.destroy();
            message.warning('请上传荣誉图片');
            return false
        }
        let result =true;
        this.state.dataSource.forEach((item,index)=>{
            if(item.index !== this.state.Honor.index){
                if(item.title === this.state.Honor.title){
                    message.destroy();
                    result = false;
                    message.warning('该称号已创建，不能重复创建。');
                }
                if(item.grade === this.state.Honor.grade){
                    message.destroy();
                    result = false;
                    message.warning('该等级已创建，不能重复创建。');
                }
                if(item.score === this.state.Honor.score){
                    result = false;
                    message.destroy();
                    message.warning('该分数已存在，不能重复创建。');
                }
            }
            if(item.index === this.state.Honor.index + 1){
                if(this.state.Honor.score >  item.score){
                    result = false;
                    message.destroy();
                    message.warning('该分数不能大于下一个分数。');
                }
            }
            if(item.index === this.state.Honor.index - 1){
                if(this.state.Honor.score < item.score){
                    result = false;
                    message.destroy();
                    message.warning('该分数不能小于上一个分数。');
                }
            }
        });


       if(!result){
           return false
       }
        this.state.dataSource.forEach((item,index)=>{
            if(item.index === this.state.Honor.index){
                this.state.dataSource[index] =  this.state.Honor;
            }
        });
        let {current} = this.state;
        current.configValue = JSON.stringify(this.state.dataSource);
        this.request({
            url:  "/cm-sites-sys/config/edit",
            method: 'post',
            contentType: "json",
            body: current,
            loading:false,
            callBack: (res) => {
                if(res){
                    message.destroy();
                    this.setState({visible:false});
                    message.success('保存成功');
                    this.getData()
                }
            },
            errorCallBack: (e) => {
                message.error('操作失败！');
            },
        })
    }






}

